import React from 'react';

import { AppProvider, Page, Card, Spinner, ResourceList } from '@shopify/polaris';
import { dispatchControlColumns } from '@utils/recordHelpers';
import CTABanner from '@presentational/information/CTABanner';

import { ResourceTableHeaders, ResourceTableBody } from '@presentational';
import FilterTableProvider from '@container/FilterTableProvider';


class DispatchControlIndex extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      dispatchs: props.dispatchs
    }
  }

  render() {
    const primaryAction = this.props.newUrl ? {content: I18n.t("actions.create_x", { x: I18n.t("activerecord.models.dispatch_control.one")}), url: this.props.newUrl} : null

    return(
      <FilterTableProvider
        pageProps={{
          title: I18n.t("activerecord.models.order_supply.other"),
          primaryAction: primaryAction
        }}
        filterURL="/admin/dispatch_controls"
        itemURL="/admin/dispatch_controls"
        searchName="search_query"
        paramsName="dispatch_control_filters"
        initialFilters={{
          search_query: ''
        }}
        initialTotalPages={ this.props.totalPages }
        initialRecords={ this.state.dispatchs }

        columnsInfo={ dispatchControlColumns }
      >
      </FilterTableProvider>

    )
  }
}

export default DispatchControlIndex;
